package fr.frux.feature.feedback

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/**
 * Contrat de fabrique du [FeedbackViewModel], honoré par le composition root (#43). L'écran
 * d'origine vient de la route, pas du graphe.
 */
fun interface FeedbackViewModelFactory {
    fun create(sourceScreen: String): FeedbackViewModel
}

/** Fabrique installée par le composition root, sans défaut : l'oubli de câblage doit crier. */
val LocalFeedbackViewModelFactory =
    staticCompositionLocalOf<FeedbackViewModelFactory> {
        error("FeedbackViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
    }

@Composable
fun rememberFeedbackViewModel(sourceScreen: String): FeedbackViewModel {
    val factory = LocalFeedbackViewModelFactory.current
    return viewModel { factory.create(sourceScreen) }
}
